export default __webpack_public_path__ + "static/media/style.286d4072.less";